module.exports = __webpack_public_path__ + "static/media/5-blue.42c79458.svg";